/** UUID event id regex source, with no anchors. Used to build a RegExp and a route param pattern. */
export const EVENT_ID_PATTERN = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
